import React from 'react'
import { Title, Subtitle, Link2, IconText } from '../../../index.js'
import { isLocal } from '../../../../../global/environments/index.js'
import DOMPurify from 'dompurify'
import '../../../../../components/EmailSubscriptionCenter/Modal/CategorySubscriptionButtonElement.js'

function AdvisorBlogArticleCard({
  item,
  taxonomies,
  children,
  hightlightOnHover = false,
}) {
  const {
    title,
    name,
    publicationDate,
    cardSummary,
    time,
    types = [],
  } = item.document.getData()
  const { imageUrl } = item.processedFields

  const prefix = isLocal()
    ? '/cti-site/blogspa/latest-insights/'
    : '/insights/latest-insights/'

  const _name = `${name}`.split('?')?.[0].split('/') || []
  const docName = _name?.[_name.length - 1] || ''

  const articlePath = DOMPurify.sanitize(`${prefix}${docName}`)
  const clickableLink = hightlightOnHover ? articlePath : null

  const CardWrapper = clickableLink
    ? ({ children, className }) => (
        <a
          href={clickableLink}
          target="_self"
          className={className}
          data-analytics="insights-card"
          style={{
            textDecoration: 'none',
            color: 'inherit',
            cursor: 'pointer',
          }}
        >
          {children}
        </a>
      )
    : ({ children, className }) => (
        <div className={className} data-analytics="insights-card">
          {children}
        </div>
      )

  const publishDate =
    publicationDate &&
    new Date(publicationDate).toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })

  const footer = () => {
    return (
      <>
        {(time || types?.length || item?.processedFields?.keys?.length) && (
          <div className="u-marginTop4gu u-sizeFull">
            <hr className="Rule Rule--thin u-marginBottom3gu" />
            <div className="u-flex">
              <div className="u-size3of8">
                {types?.map((type, index) => (
                  <IconText key={index} icon={type} text={type} />
                ))}
                {time ? <IconText icon="Time" text={time} /> : ''}
              </div>
              <div className="u-flex u-flexCol u-flexAlignItemsEnd u-size5of8">
                {item?.processedFields?.keys?.map((key, index) => (
                  <React.Fragment key={key}>
                    {key && key !== 'client-materials' && (
                      <div
                        className="u-textColorBrandLight u-textItalic u-textCapitalize u-textSizeMsrm1"
                        style={{
                          marginTop: index > 0 ? 5 : 2,
                          paddingTop: 2,
                          paddingBottom: 2,
                        }}
                      >
                        <a
                          className="u-flex u-flexAlignItemsCenter u-textRight"
                          href={DOMPurify.sanitize(`${prefix}?topic=${key}`)}
                        >
                          {(taxonomies?.length > 0 &&
                            taxonomies.find((taxonomy) => taxonomy.key === key)
                              ?.name) ||
                            key.replaceAll('-', ' ')}
                        </a>
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        )}
      </>
    )
  }

  return (
    <CardWrapper
      className={`BlogArticleCardWrapper u-flex u-flexCol u-bgColorWhite u-decoBorderLightFull u-marginBottom5gu u-sm-sizeFull u-md-size1of3 u-lg-size1of3 ${clickableLink ? 'card-hover' : ''}`}
    >
      <div
        className={`BlogArticleCard u-posRelative u-flex u-flexCol u-flexAlignItemsStart u-flexAuto u-sizeFull`}
      >
        {children}
        <a
          href={DOMPurify.sanitize(articlePath)}
          target="_self"
          className="u-sizeFull"
        >
          <div
            className="banner-background-image u-block u-posRelative u-flexAlignItemsCenter blog-article-image-link"
            data-analytics="insights-card-img"
            style={
              imageUrl ? { backgroundImage: 'url("' + imageUrl + '")' } : {}
            }
            alt="img"
            aria-label={title}
          ></div>
        </a>
        <div className="u-flex u-flexCol u-flexAuto u-sizeFull u-padding4gu u-flexAlignItemsStart">
          <Link2 url={articlePath} className="u-textColorBrandLight">
            <Title
              text={title}
              textColor="u-textColorBrandLight"
              mode="medium-large"
              data-analytics="insights-card-headline"
            />
          </Link2>
          {publishDate && (
            <Subtitle
              text={publishDate}
              mode="small-bold"
              className="u-inline u-marginTop1gu"
            />
          )}
          <div className="u-flex u-flexCol u-flexAuto u-sizeFull">
            <div className="Content u-flexAuto u-paddingBottom0">
              {cardSummary && <p>{cardSummary}</p>}
            </div>
            {footer()}
          </div>
        </div>
      </div>
    </CardWrapper>
  )
}

export default AdvisorBlogArticleCard
